<template>
  <div class="orgnavbox">
    <div class="title">
      <span class="before">{{$t(titleList.before)}}</span>
      <span class="dot"></span>
      <span class="after">{{$t(titleList.after)}}</span>
    </div>
    <div class="info">
      {{$t(titleList.info)}}
    </div>

    <div class="tabbar">
      <template v-if="isShowItem">
        <div
            class="tabbar-box"
            :class="index + 1 != dataList.length ? 'tabbar-box-right' : ''"
            v-for="(item, index) in dataList"
            :key="item.id"
            @click="handleChange(index)"
        >
            <div>
            <img class="img" :src="item.icon" alt="" />
            </div>
            <div class="tabbar-title">{{ $t(item.name) }}</div>
            <div :class="currentIndex == index ? 'tabbar-active' : ''"></div>
        </div>
      </template>
      <template v-else>
          <div
          style="cursor:default;"
            class="tabbar-box" 
            :class="index + 1 != dataList.length ? 'tabbar-box-right' : ''"
            v-for="(item, index) in dataList"
            :key="item.id"
        >
            <div>
            <img class="img" :src="item.icon" alt="" />
            </div>
            <div class="tabbar-title">{{ $t(item.name) }}</div> 
            <div :class="currentIndex == index ? 'tabbar-active' : ''" style="border-bottom:none;"></div>
        </div>
      </template>
    </div>

    <div class="tabbar-item" v-if="isShowItem">
        <!-- 从上至下移动  -->
      <div
        class="trans"
        :style="{
          height: 500 * bannarList.length + 'px',
          top: -currentIndex * 500 + 'px',
        }"
      >
        <img
          v-for="item in bannarList"
          :key="item.id"
          class="img"
          :src="item.url"
        />
      </div>
      <!-- 从左至右移动 -->
      <!-- <div
        class="trans"
        :style="{
          width: 1920 * bannarList.length + 'px',
          left: -currentIndex * 1920 + 'px',
        }"
      >
        <img
          v-for="item in bannarList"
          :key="item.id"
          class="img"
          :src="item.url"
        />
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      required: true,
    },
    bannarList: {
      type: Array,
      default:  ()=> {
        return []
      }
    },
    titleList:{
      type:Object,
      required:true
    },
    isShowItem:{
      type:Boolean,
      default:true
    }
  },
  data () {
    return {
      currentIndex: 0,
      // bannarList,
    }
  },
  methods: {
    handleChange (index) {
      this.currentIndex = index
    },
  },
}
</script>

<style lang="scss" scoped>
.orgnavbox {
  width: 100%;
  padding-top: 60px;
  box-sizing: border-box;
  .title {
    width: 100%;
    height: 80px;
    color: #333333;
    font-size: 40px;
    font-weight: 200;
    text-align: center;
    .before {
      font-weight: 200;
    }
    .dot {
      display: inline-block;
      width: 10px;
      height: 10px;
      line-height: 80px;
      margin-bottom: 8px;
      border-radius: 10px;
      background-color: #2f68c9;
    }
  }
  .info {
    text-align: center;
    color: #333333;
    font-size: 16px;
    line-height: 60px;
  }
  .tabbar {
    width: 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    .tabbar-box {
      height: 100px;
      box-sizing: border-box;
      text-align: center;
      margin-bottom: 5px;
      margin-top: 15px;
      width: 126px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      cursor: pointer;
      .tabbar-title {
        font-weight: 800;
      }
      img {
        width: 66px;
      }
  
      .tabbar-active {
        width: 66px;
        margin: 0 auto;
        border-bottom: 3px solid #5ba8ff;
        box-sizing: border-box;
      }
    .desrtory-blue{
        border-bottom: none;
    }
    }
    .tabbar-box-right {
      margin-right: 120px;
    }
   
  }
  .tabbar-item {
    box-sizing: border-box;
    width: 100%;
    height: 500px;
    position: relative;
    overflow: hidden;

    .trans {
      display: flex;
      flex-direction: column;
      transform: trans;
      transition: 0.4s;
      position: absolute;
      box-sizing: border-box;
      top: 0;
      left: 0;
      .img {
        width: 100%;
        height: 500px;
      }
      @keyframes trans {
        0% {
          left: 0;
        }
        100% {
          left: 1920px;
        }
      }
    }
    //从左至右移动
    // .trans {
    //   display: flex;
    //   flex-direction: row;
    //   transform: trans;
    //   transition: 1s;
    //   position: absolute;
    //   box-sizing: border-box;
    //   top: 0;
    //   left: 0;
    //   .img {
    //     width: 100%;
    //   }
    //   @keyframes trans {
    //     0% {
    //       left: 0;
    //     }
    //     100% {
    //       left: 1920px;
    //     }
    //   }
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/home/detail/components/Orgnavbox.vue